import script from "./settingsWalk.vue?vue&type=script&setup=true&lang=js"
export * from "./settingsWalk.vue?vue&type=script&setup=true&lang=js"

import "./settingsWalk.vue?vue&type=style&index=0&id=1c190ee1&lang=scss&scoped=true"
import "./settingsWalk.vue?vue&type=style&index=1&id=1c190ee1&lang=css"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c190ee1"]])

export default __exports__